type Event = 'error' | 'connected';
type CallbackData = $TSFixMe; // TODO: get types for socket/error from graphql-ws
type Callback = (data: CallbackData) => void;
type Subscriptions = Record<Event, Record<number, Callback>>;
type Disposal = { dispose: () => void };

const subscriptions: Subscriptions = {
    error: {},
    connected: {},
};

let id = 0;

const getId = (): number => {
    id++;
    return id;
};

export const subscribe = (event: Event, callback: Callback): Disposal => {
    const eventId = getId();
    subscriptions[event][eventId] = callback;

    return {
        dispose: () => {
            if (subscriptions?.[event]?.[eventId]) {
                delete subscriptions[event][eventId];
            }
        },
    };
};

export const emit = (event: Event, data: CallbackData): void => {
    Object.values(subscriptions?.[event] || {}).forEach(callback => callback(data));
};

export const subscriptionEventHandlers = {
    error: (err: CallbackData): void => emit('error', err),
    connected: (socket: CallbackData): void => emit('connected', socket),
};
